import Nullstack from 'nullstack';
export default function IconOld({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-old",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 21l-1 -4l-2 -3v-6"
  }), "   ", Nullstack.element("path", {
    d: "M5 14l-1 -3l4 -3l3 2l3 .5"
  }), "   ", Nullstack.element("circle", {
    cx: "8",
    cy: "4",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M7 17l-2 4"
  }), "   ", Nullstack.element("path", {
    d: "M16 21v-8.5a1.5 1.5 0 0 1 3 0v.5"
  }), " ");
}